import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import UserDefaultImage from "../../assets/images/UserDefultImage.png";
import SubHeaderMenu from "../Sidebar/SubHeaderMenu";
import CustomerPersonalInfo from "./CustomerPersonalInfo";
import TransactionHistory from "./TransactionHistory";
import ReferralList from "./ReferralList";
import useNetworkServices from "../../Networking/baseAPIManager";
import Loader from "../Common/Loader";

const CustomerOverviewDetail = () => {
  const { customerList } = useNetworkServices();
  const [customerData, setCustomerData] = useState({});
  const [activeTab, setActiveTab] = useState(0);
  const [loading, setLoading] = useState(false);
  const location = useLocation();
  const id = location?.state;

  // Fetch customer details
  const customerDetailList = async () => {
    const queryId = { id: id };
    const queryData = new URLSearchParams(queryId).toString();

    try {
      setLoading(true);
      const response = await customerList(queryData);
      setCustomerData(response?.data?.data[0]);
    } catch (error) {
      console.error("Error fetching customer data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    customerDetailList();
  }, []);

  const BASE_URL_IMG = process.env.REACT_APP_BASE_URL_IMG;

  // Determine user image
  const userImage = customerData?.userDetails?.photo
    ? typeof customerData?.userDetails?.photo === "object"
      ? URL.createObjectURL(customerData?.userDetails?.photo)
      : `${BASE_URL_IMG}/${customerData?.userDetails?.photo}`
    : UserDefaultImage;

  const tabs = [
    {
      title: "Transaction History",
      content: <TransactionHistory customerData={customerData?.transactions} />,
    },
    {
      title: "Referral",
      content: <ReferralList customerData={customerData} />,
    },
  ];

  return (
    <div id="main" className="p-4">
      <h1 className="font-bold text-2xl text-slate-900 pb-5">
        <span>Customer Management</span> /
        <span className="text-red-500">
          <SubHeaderMenu location={location} />
        </span>
      </h1>

      <div className="w-full p-6 xl:flex justify-between lg:flex md:flex sm:flex">
        <div className="w-1/2 xl:flex lg:flex md:flex sm:flex items-center border-[#CBCCCE] border-r-[1px]">
          <div className="relative w-20 h-20 overflow-hidden bg-gray-100 rounded-full dark:bg-gray-600">
            <img src={userImage} alt="Profile" className="object-cover w-full h-full" />
          </div>
          <div className="ps-4">
            <h3 className="text-xl font-bold text-gray-900">
              {`${customerData?.userDetails?.fullName || "N/A"}`}
            </h3>
            <h6 className="text-md font-semibold text-gray-600 pt-1">
              {customerData?.userDetails?.email || "N/A"}
            </h6>
            <h6 className="text-md font-semibold text-gray-600 pt-1">
              {customerData?.userDetails?.mobile || "N/A"}
            </h6>
          </div>
        </div>

        <div className="w-1/2 pt-5 xl:pt-0 lg:pt-0">
          <div className="ps-4">
            <h3 className="text-xl font-bold text-gray-900">Cashfuse Points</h3>
            <h6 className="text-md font-semibold text-gray-600 pt-1 pe-5">
              {customerData?.userDetails?.reward_points || "0"}
            </h6>
          </div>
        </div>
      </div>

      <div>
        {/* Tabs Navigation */}
        <div className="flex border-b border-gray-200 mb-4">
          {tabs.map((tab, index) => (
            <button
              key={index}
              className={`px-4 py-2 font-semibold text-sm ${
                activeTab === index
                  ? "border-b-2 border-custom-red text-custom-red bg-custom-red2 rounded-t-md"
                  : "text-gray-500"
              }`}
              onClick={() => setActiveTab(index)}
            >
              {tab.title}
            </button>
          ))}
        </div>

        {/* Active Tab Content */}
        <div>{tabs[activeTab].content}</div>
      </div>
      {loading && <Loader />}
    </div>
  );
};

export default CustomerOverviewDetail;
    